module.exports = __webpack_public_path__ + "static/img/tip.2d68bd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/common/img/tip.png
// module id = 6BZy
// module chunks = 37